import type { RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import { beforeEnterWorkspace } from "@/views/workspace/hooks";
import { getModuleLabelByKey, getModuleRouteKeyByKey } from "@xmiles/holopix-helper";

const workspaceModulesRoutes: RouteRecordRaw[] = [
  {
    path: "/workspace/explore",
    name: "explore",
    meta: {
      group: "workspace",
      label: getModuleLabelByKey("explore"),
      // auth: true,
      layout: "create",
      useTopbar: true
    },
    component: () => import("@/views/workspace/children/explore/index.vue")
  },
  {
    path: "/workspace/colour",
    name: "colour",
    meta: {
      group: "workspace",
      label: getModuleLabelByKey("colour"),
      // auth: true,
      layout: "create",
      useTopbar: true
    },
    component: () => import("@/views/workspace/children/colour/index.vue")
  },
  {
    path: "/workspace/refine",
    name: "refine",
    meta: {
      group: "workspace",
      label: getModuleLabelByKey("refine"),
      // auth: true,
      layout: "create",
      useTopbar: true
    },
    component: () => import("@/views/workspace/children/refine/index.vue")
  },

  //   AI 视频
  {
    path: "/workspace/aivideo",
    name: "aivideo",
    meta: {
      group: "workspace",
      label: getModuleLabelByKey("aivideo"),
      // auth: true,
      layout: "create",
      useTopbar: true
    },
    component: () => import("@/views/workspace/children/aivideo/index.vue")
  },

  {
    path: "/workspace/fission",
    name: "fission",
    meta: {
      group: "workspace",
      label: getModuleLabelByKey("fission"),
      // auth: true,
      layout: "create",
      useTopbar: true
    },
    component: () => import("@/views/workspace/children/fission/index.vue")
  },
  {
    path: "/workspace/threeTransform",
    name: "threeTransform",
    meta: {
      group: "workspace",
      label: getModuleLabelByKey("threeTransform"),
      // auth: true,
      layout: "create",
      useTopbar: true
    },
    component: () => import("@/views/workspace/children/threeTransform/index.vue")
  },
  {
    path: "/workspace/sketch",
    name: "sketch",
    meta: {
      group: "workspace",
      label: getModuleLabelByKey("sketch"),
      // auth: true,
      layout: "create",
      useTopbar: true
    },
    component: () => import("@/views/workspace/children/sketch/index.vue")
  },
  {
    path: "/workspace/matting",
    name: "matting",
    meta: {
      group: "workspace",
      label: getModuleLabelByKey("matting"),
      // auth: true,
      layout: "create",
      useTopbar: true
    },
    component: () => import("@/views/workspace/children/matting/index.vue")
  },
  {
    path: "/workspace/replace",
    name: "replace",
    meta: {
      group: "workspace",
      label: getModuleLabelByKey("replace"),
      // auth: true,
      layout: "create",
      useTopbar: true
    },
    component: () => import("@/views/workspace/children/replace/index.vue")
  },
  {
    path: "/workspace/zoom",
    name: "zoom",
    meta: {
      group: "workspace",
      label: getModuleLabelByKey("zoom"),
      // auth: true,
      layout: "create",
      useTopbar: true
    },
    component: () => import("@/views/workspace/children/zoom/index.vue")
  },
  {
    path: "/workspace/expansion",
    name: "expansion",
    meta: {
      group: "workspace",
      label: getModuleLabelByKey("expansion"),
      // auth: true,
      layout: "create",
      useTopbar: true
    },
    component: () => import("@/views/workspace/children/expansion/index.vue")
  },
  // 像素图转换
  {
    path: "/workspace/pixelate",
    name: "pixelate",
    meta: {
      group: "workspace",
      label: getModuleLabelByKey("pixelate"),
      // auth: true,
      layout: "create",
      useTopbar: true
    },
    component: () => import("@/views/workspace/children/pixelate/index.vue")
  },
  // 表情生成
  {
    path: "/workspace/expression",
    name: "expression",
    meta: {
      group: "workspace",
      label: getModuleLabelByKey("expression"),
      // auth: true,
      layout: "create",
      useTopbar: true
    },
    component: () => import("@/views/workspace/children/expression/index.vue")
  },

  //万能渲染器
  {
    path: "/workspace/render",
    name: getModuleRouteKeyByKey("render"),
    meta: {
      group: "workspace",
      label: getModuleLabelByKey("render"),
      // auth: true,
      layout: "create",
      useTopbar: true
    },
    component: () => import("@/views/workspace/children/render/index.vue")
  },
  // 自由视角生图
  {
    path: "/workspace/freePerspective",
    name: "freePerspective",
    meta: {
      group: "workspace",
      label: getModuleLabelByKey("freePerspective"),
      // auth: true,
      layout: "create",
      useTopbar: true
    },
    component: () => import("@/views/workspace/children/freePerspective/index.vue")
  }
];

/**
 * 创作工具
 */
const creativeToolsRoutes: RouteRecordRaw[] = [
  {
    path: "/creative-tool/three-transform",
    name: "creative-tool-three-transform",
    component: () => import("@/views/workspace/creative-tool/threeTransform/index.vue"),
    meta: {
      group: "workspace",
      layout: "create",
      notUseSider: true,
      useTopbar: true
    }
  },
  {
    path: "/creative-tool/advanced",
    name: "creative-tool-advanced",
    component: () => import("@/views/workspace/creative-tool/advanced/index.vue"),
    meta: {
      group: "workspace",
      // auth: true,
      layout: "create",
      notUseSider: true,
      useTopbar: true
    }
  },
  {
    path: "/creative-tool/quick",
    name: "creative-tool-quick",
    component: () => import("@/views/workspace/creative-tool/quick/index.vue"),
    meta: {
      group: "workspace",
      // auth: true,
      layout: "create",
      notUseSider: true,
      useTopbar: true
    }
  },
  {
    path: "/creative-tool/role",
    name: "creative-tool-role",
    component: () => import("@/views/workspace/creative-tool/role/index.vue"),
    meta: {
      group: "workspace",
      // auth: true,
      layout: "create",
      notUseSider: true,
      useTopbar: true
    }
  }
];

const workspaceRoutes: RouteRecordRaw[] = [
  {
    path: "/workspace",
    name: "workspace",
    component: () => import("@/views/workspace/index.vue"),
    beforeEnter: async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
      await beforeEnterWorkspace(to, from);
    },
    meta: {
      // auth: true,
      layout: "create",
      notUseSider: true,
      useTopbar: true
    },
    children: [...workspaceModulesRoutes, ...creativeToolsRoutes]
  }
];

export default workspaceRoutes;
